// libraries
import styled from 'styled-components';

export const StyledMapDashboard = styled.div`
  width: 100%;
  height: 100%;
  min-height: 0;

  .md-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;

    &-top {
      width: 100%;
      padding-bottom: 15px;
      display: flex;
      align-items: center;
      gap: 12px;
      overflow-x: scroll;
      flex-shrink: 0;

      &-total {
        padding: 10px 14px;
        border-radius: 6px;
        color: #fff;
        background: var(--color-primary-blue);
        font-size: 14px;
        font-weight: 500;
        line-height: 21px;
      }
    }

    &-middle {
      width: 100%;
      flex: 1;
      min-height: 0;
      padding: 8px;
      background: #fff;
      border-radius: 10px;
      box-shadow: 0px 0px 6px 0px #00000026;
      position: relative;

      &-btns {
        position: absolute;
        top: 21px;
        left: 18px;
        display: flex;
        align-items: center;
        z-index: 1;
        background: #fff;
        border-radius: 4px;
        border: 1px solid #b99c5d;
        box-shadow: 0px 0px 8px 0px #b99c5d40;

        &-btn {
          padding: 6px 14px;
          cursor: pointer;
          font-size: 14px;
          font-weight: 500;
          line-height: 18px;
          text-align: center;
          color: #585959;
          transition: all 0.3s ease-in-out;

          &.active {
            background: #b99c5d;
            color: #fff;
            border: 0.2px solid #d3d3d3;
            border-radius: 4px;
            box-shadow: 0px 0px 1px 0px #0f224329;
            box-shadow: 0px 1px 3px 0px #0f22431f;
            box-shadow: 0px 4px 16px -6px #0f224329;
          }
        }
      }
    }
  }
`;

export const StyledMapDashboardTopBox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
